/* eslint-disable import/prefer-default-export */
import 'normalize.css/normalize.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import AppRouter from './routers/AppRouter';
import configureStore from './app/store/configureStore';
import initialization from './app/initialization';

import './styles/styles.scss';

export const store = configureStore();

const jsx = (
  <Provider store={store}>
    <AppRouter />
  </Provider>
);

initialization(store);

ReactDOM.render(jsx, document.getElementById('app'));
